import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const { user, signOut: contextSignOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await contextSignOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <h1 className="header-title">User Management System</h1>
        <nav className="nav">
          <Link to="/dashboard">Dashboard</Link>
          {user?.userType === 'admin' && (
            <>
              <Link to="/register-user">Register User</Link>
              <Link to="/users">Manage Users</Link>
            </>
          )}
          {user && (
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '20px' }}>
              <span>Welcome, {user.email}</span>
              <span className={`user-type-badge ${user.userType}`}>
                {user.userType}
              </span>
              <button onClick={handleSignOut} className="btn btn-secondary">
                Sign Out
              </button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;